// import VueSocketIO from 'vue-socket.io'
var wesocket = {
  debug: true, // 记录调试消息,消息被打印到console.debug()
  connection: ''
}
const socket = (t) => {
  var socketIp = '' // socket地址
  wesocket.connection = socketIp
  if (localStorage.getItem('Token') || t) { // 判断是否有token
    const tk = localStorage.getItem('Token') ? localStorage.getItem('Token') : t
    wesocket.connection = socketIp + '?usekey=' + tk
  }
  if (wesocket.connection !== '') {
    // Vue.use(new VueSocketIO(wesocket))
  }
}
export default socket
